import React from 'react';
import styles from "../../styles/components/frameworkBanner.module.scss";
import endpoints from '../../utility/endpoints'

export default function index(props) {
  //console.log(props, "framaework page image")

  const { field_background_image, field_background_image_mobile, field_hedaing, field_details } = props.data

  return (
    <div className={`${styles.frameworkbannerWrapper} container-fluid`}>
      <div className={`${styles.row} row`}>
        <div className="col-12">
        <div className={styles.imaging}>
          <img className={styles.image} src={endpoints.drupalIp + field_background_image[0].file_url} alt={field_background_image[0].image_alt} />
          <img className={styles.imageMobile} src={endpoints.drupalIp + field_background_image_mobile[0].file_url} alt="abc" />
        </div>
          <div className={`${styles.container} container py-4`}>
            <p className={styles.frameworkbannerHead}>{field_hedaing}</p>
            <div
              className={styles.frameworkbannerText}
              dangerouslySetInnerHTML={{
                __html: field_details
              }}
            >
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
